import getGifSearchResults, { BingGifValue } from '../services/getGifSearchResults';
import expressionStore from '../store/expressionStore';
import GifPickerViewState from '../store/schema/GifPickerViewState';
import GifSearchMethod from '../store/schema/GifSearchMethod';

export default async function matchGif(
    searchTerm: string,
    searchMethod: GifSearchMethod,
    gifDummyCallback: () => void
): Promise<BingGifValue[]> {
    let gifSearchResults: BingGifValue[];

    try {
        const gifPickerViewState: GifPickerViewState =
            expressionStore.expressionPickerViewState &&
            expressionStore.expressionPickerViewState.gifPickerViewState;
        gifSearchResults = gifPickerViewState
            ? await getGifSearchResults(searchTerm, gifPickerViewState.culture, searchMethod)
            : null;

        gifDummyCallback();
    } catch {
        gifSearchResults = null;
    }

    return gifSearchResults;
}
